import { z } from "zod";

export const VictimStatusZ = z.enum(["murdered", "missing", "unsolved", "survived"]);
export type VictimStatus = z.infer<typeof VictimStatusZ>;